<script setup>
defineProps({
    size: {
        type: Number,
        default: 24,
    },
    // Turns the mark at an uneven pace while Lens is working.
    spinning: Boolean,
});
</script>

<template>
    <svg :width="size" :height="size" viewBox="0 0 32 32" aria-hidden="true" :class="{ 'lens-mark--spinning': spinning }">
        <circle cx="16" cy="16" r="15" fill="#fff" stroke="#3880EE" stroke-width="1.5" />
        <path d="M16 4 a12 12 0 0 1 10.39 6 L16 16 Z" fill="#3880EE" opacity="0.95" />
        <path d="M26.39 22 a12 12 0 0 1 -20.78 0 L16 16 Z" fill="#39B556" opacity="0.95" />
        <path d="M5.61 22 a12 12 0 0 1 0 -12 L16 16 Z" fill="#E54C2E" opacity="0.95" />
        <circle cx="16" cy="16" r="3.6" fill="#fff" />
        <circle cx="16" cy="16" r="3.6" fill="none" stroke="rgba(0,0,0,0.18)" stroke-width="0.6" />
    </svg>
</template>

<style scoped>
/* Slow, fast, slow, fast: each step covers a different arc in a different share of the cycle. */
.lens-mark--spinning {
    animation: lens-mark-stutter 2.4s linear infinite;
}

@keyframes lens-mark-stutter {
    0% {
        transform: rotate(0deg);
    }
    30% {
        transform: rotate(60deg);
    }
    45% {
        transform: rotate(200deg);
    }
    75% {
        transform: rotate(250deg);
    }
    90% {
        transform: rotate(330deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

@media (prefers-reduced-motion: reduce) {
    .lens-mark--spinning {
        animation-duration: 6s;
        animation-timing-function: linear;
    }
}
</style>
